import type { FC, ReactNode } from 'react'
import type { Memory } from '@/types'

import { Reveal } from '@/components/generals/reveal'
import { SectionHeading } from '@/components/generals/section-heading'

import MemoryCard from '@/components/family/memory-card'

interface MemoriesSectionProps {
    memories: Array<Memory>
}

const MemoriesSection: FC<MemoriesSectionProps> = ({ memories }): ReactNode => {
    return (
        <section id='memories' className='px-5 py-20 md:px-8 md:py-24'>
            <div className='mx-auto max-w-6xl'>
                <SectionHeading
                    align='center'
                    eyebrow="Memories"
                    title="In the words of the family"
                    text="Stories, small moments and things we never want to forget, shared by the people who lived them."
                />

                <ul className='mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3'>
                    {memories.map((memory, index) => (
                        <Reveal as='li' key={memory.id} delay={index * 90}>
                            <MemoryCard memory={memory} />
                        </Reveal>
                    ))}
                </ul>
            </div>
        </section>
    )
}

export default MemoriesSection
